/**
 * Mail — external-URL sentinel. Opens Hostinger webmail for the
 * mail@lottel.fun mailbox in a new tab. WinXP/index.js checks for the
 * `externalUrl` static and short-circuits with window.open, same pattern
 * as Twitch/Discord.
 */

function Mail() {
  return null;
}

Mail.externalUrl = 'https://mail.hostinger.com';

export default Mail;
